export const formatMoney = (value, { decimals = 0 } = {}) => {
  const amount = Number(value || 0);
  return `Rs ${new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount)}`;
};

export const formatNumber = (value) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 }).format(Number(value || 0));

export const formatCount = (count, singular) => {
  const n = Number(count || 0);
  return `${formatNumber(n)} ${n === 1 ? singular : `${singular}s`}`;
};

export const formatTimes = (count) => formatCount(count, "time");

export const formatDate = (value) => {
  if (!value) return "—";
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

export const todayLabel = () =>
  new Intl.DateTimeFormat("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date());

export const entryLabel = (type) => {
  if (type === "expense") return "Expense";
  if (type === "down_payment") return "Down payment";
  if (type === "vendor_payment") return "Vendor payment";
  return "Installment";
};

export const formatMonth = (value) => {
  if (!value) return "—";
  const date = new Date(`${value}-01T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("en-GB", { month: "long", year: "numeric" }).format(date);
};

export const roundMoney = (value) =>
  Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

export const calcSalePreview = ({
  totalAmount,
  downPayment,
  installmentMonths,
  planMode = "equal",
  planRows = [],
}) => {
  const total = roundMoney(totalAmount);
  const down = roundMoney(downPayment);
  const months = Number(installmentMonths) || 0;
  const remaining = roundMoney(Math.max(total - down, 0));
  const monthly = months > 0 && remaining > 0 ? roundMoney(remaining / months) : 0;
  const customSum = roundMoney(
    (planRows || []).reduce((sum, row) => sum + Number(row.amount || 0), 0)
  );
  const planOk = remaining === 0 || planMode !== "custom" || customSum === remaining;
  return {
    total,
    down,
    remaining,
    monthly,
    customSum,
    planOk,
    invalid: down > total || (remaining > 0 && !planOk),
  };
};

export const paidPercent = (received, total) => {
  if (!total) return 0;
  return Math.min(100, Math.round((Number(received || 0) / Number(total)) * 100));
};
